import { takeLatest, put, call } from 'redux-saga/effects';

import { MANAGE_INSURANCES_ACTION_TYPES } from '../actions/manage-insurances-actions';
import { editUserAfterInsuranceUpdate } from './edit-user-after-insurance-update';
import { insuranceErrorModalActions } from '../../appointmentForm/handle-insurance-error-modal';
import { actions as insuranceEligibilityManualActivationsActions } from '../../profiles/insurance-eligibility-manual-activations';

function* runManualEligibilityActivationWorker({ payload }) {
  const {
    userId,
    insuranceEligibilityResultId,
    skipInsurance,
    finishAction,
    flowType,
  } = payload;

  yield put(
    insuranceEligibilityManualActivationsActions.send({
      userId,
      insuranceEligibilityResultId,
    }),
  );

  yield put(insuranceErrorModalActions.close());

  yield call(editUserAfterInsuranceUpdate, {
    userId,
    skipInsurance,
    finishAction,
    flowType,
  });
}

export function* runManualEligibilityActivation() {
  yield takeLatest(
    MANAGE_INSURANCES_ACTION_TYPES.RUN_MANUAL_ELIGIBILITY_ACTIVATION,
    runManualEligibilityActivationWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/run-manual-eligibility-activation.js